import { get, post, put, remove } from '../common/http';

class UserApi {

    static async getUserList(params) {
        const { page, count, keyword } = params;
        const res = await get(`/api/users?page=${page}&count=${count}&keyword=${keyword}`);
        return res;
    }

    static async createUser(userData) {
        console.log('userData', userData);
        const res = await post('/api/users', userData);
        return res;
    }

    static async updateUser(userId, userData) {
        const res = await put(`/api/users/${userId}`, userData);
        return res;
    }

    static async deleteUser(userId) {
        const res = await remove(`/api/users/${userId}`);
        return res;
    }

    static async deleteUsers(userIds) {
        const res = await post('/api/users/delete-multiple', { userIds });
        return res;
    }

    static async getUserById(userId) {
        const res = await get(`/api/users/${userId}`);
        return res;
    }

    static async updateUserRole(userId, role) {
        const res = await put(`/api/users/${userId}/role`, { role });
        return res;
    }

    static async updateUserPassword(userId, password) {
        const res = await put(`/api/users/${userId}/password`, { password });
        return res;
    }
}

export default UserApi; 